(() => {
  const root = document.querySelector("[data-atom-faq]");
  if (!root) return;

  const input = root.querySelector("[data-faq-search]");
  const items = Array.from(root.querySelectorAll("[data-faq-item]"));
  const groups = Array.from(root.querySelectorAll("[data-faq-group]"));
  const cards = Array.from(root.querySelectorAll("[data-faq-topic-card]"));
  const empty = root.querySelector("[data-faq-empty]");

  if (!input || !items.length) return;

  const normalise = (value) => value.toLowerCase().replace(/\s+/g, " ").trim();

  const applyFilter = () => {
    const query = normalise(input.value);
    let visibleCount = 0;

    items.forEach((item) => {
      const text = normalise(item.dataset.faqSearchText || item.textContent || "");
      const matches = !query || text.includes(query);
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    groups.forEach((group) => {
      const hasVisibleItem = Boolean(group.querySelector("[data-faq-item]:not([hidden])"));
      group.hidden = !hasVisibleItem;
    });

    cards.forEach((card) => {
      const key = card.dataset.faqTopicCard;
      const group = key ? root.querySelector(`[data-faq-group="${CSS.escape(key)}"]`) : null;
      card.hidden = Boolean(query) && (!group || group.hidden);
    });

    if (empty) empty.hidden = visibleCount > 0;
  };

  input.addEventListener("input", applyFilter, { passive: true });
})();
